import { render, staticRenderFns } from "./index.vue?vue&type=template&id=30c9c949"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=30c9c949&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30c9c949')) {
      api.createRecord('30c9c949', component.options)
    } else {
      api.reload('30c9c949', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=30c9c949", function () {
      api.rerender('30c9c949', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dataeaseTabs/index.vue"
export default component.exports